import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { name: 'LinkedIn', icon: 'ri-linkedin-fill', url: 'https://www.linkedin.com/in/wade-ambrose-599aa674' }
  ];

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
              Wade Ambrose
            </h3>
            <p className="text-gray-400 max-w-sm">
              Senior Product/UX Designer crafting meaningful digital experiences that bridge user
              needs with business goals.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Quick Links</h4>
            <div className="flex flex-col space-y-2">
              <Link
                to="/about"
                className="text-gray-400 hover:text-white transition-colors duration-300"
              >
                About Me
              </Link>
              <Link
                to="/work"
                className="text-gray-400 hover:text-white transition-colors duration-300"
              >
                Case Studies
              </Link>
              <Link
                to="/contact"
                className="text-gray-400 hover:text-white transition-colors duration-300"
              >
                Get In Touch
              </Link>
            </div>
          </div>

          {/* Social Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Connect</h4>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-purple-500 text-gray-400 hover:text-white rounded-full transition-all duration-300 cursor-pointer"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Wade Ambrose. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            className="text-gray-400 hover:text-white text-sm transition-colors duration-300 mt-2 md:mt-0 cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
